import type TableView from 'owa-mail-list-store/lib/store/schema/TableView';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import isSenderImageEnabled from 'owa-messagelist-layout-option/lib/utils/isSenderImageEnabled';
import shouldHideMessageListCheckboxes from 'owa-messagelist-layout-option/lib/utils/shouldHideMessageListCheckboxes';

export default function showPersonaCheckbox(
    isSearchTable: boolean,
    tableView: TableView | undefined
): boolean {
    // Under the ML checkbox behavior flight with sender images off, the row
    // checkbox is removed entirely. Bail out before any other logic so the
    // PersonaCheckbox is never mounted and we can't fall into select-all state.
    if (shouldHideMessageListCheckboxes()) {
        return false;
    }

    // Always show the checkbox in search table
    if (isSearchTable) {
        return true;
    }

    const senderImageEnabled = isSenderImageEnabled();

    // If the reselect flight is enabled show the checkbox if sender images are enabled
    // Do not show the checkbox if we are optimistically in checked mode
    if (isGlobalFeatureEnabled('tri-reselect-checkbox-behavior')) {
        if (senderImageEnabled) {
            return true;
        } else {
            return !!tableView?.isInCheckedMode && !tableView?.isOnlyOptimisticallyInCheckedMode;
        }
    }

    // Otherwise show the checkbox if sender images are enabled, we are in select all state, or in checked mode
    return senderImageEnabled || !!tableView?.isInSelectAllState || !!tableView?.isInCheckedMode;
}
